<template>
  <div>
    <div class="bigScreen">
      <div class="link">
        <!-- <div class="link_left">
          <div class="link_left_title">快速链接</div>
          <div class="link_left_herf">
            <div v-for="item in linkType" :key="item.name" class="link_left_herf_warpper">
              <a href="#" @click="openTankUrl(item)" :title="item.name">{{ item.name }}</a>
            </div>
          </div>
        </div> -->
        <div class="link_left">
          <div class="link_left-item">
            <span>指导单位 &nbsp;</span>
            <span
              class="itemStyle"
              v-for="item in GuidingList"
              @click="openTankUrl(item)"
            >
              {{ item.title }}&nbsp;&nbsp;</span
            >
          </div>
          <div class="link_left-item">
            <span>主办单位 &nbsp;</span>
            <span v-for="item in OrganizerList">{{ item.title }}</span>
          </div>
          <div class="link_left-item">
            <span>协办单位 &nbsp;</span>
            <span v-for="item in CoorganizerList">{{ item.title }}</span>
          </div>
        </div>
        <div class="link_mid">
          <div class="link_mid_title">联系方式</div>
          <div class="link_mid_phone">
            <span>联系方式：</span
            ><span v-for="item in ContactWayList">{{ item.title }}</span>
          </div>
          <div class="link_mid_address">
            <span>地址：</span
            ><span v-for="item in AddressList" :title="item.title">{{
              item.title
            }}</span>
          </div>
        </div>
        <div class="link_right">
          <div>
            <img :src="qrCode" alt="公众号二维码" />
            <div class="link_right_text">四川省再生资源行业协会公众号</div>
          </div>
        </div>
      </div>
      <div class="copyright">
        <span>版权所有 © 天府再生资源公司</span>
        <img :src="require('@/assets/recycling/index/record-img.png')" alt="" />
        <a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          rel="noreferrer"
          target="_blank"
        >
          蜀ICP备2025151940号
        </a>
      </div>
    </div>
    <div class="smallScreen">
      <div class="link1">
        <div class="link_left">
          <div class="link_left-item">
            <h6>指导单位</h6>
            <p
              class="itemStyle"
              v-for="item in GuidingList"
              @click="openTankUrl(item)"
            >
              {{ item.title }}
            </p>
          </div>
          <div class="link_left-item">
            <h6>主办单位</h6>
            <p class="itemStyle" v-for="item in OrganizerList">
              {{ item.title }}
            </p>
          </div>
          <div class="link_left-item">
            <h6>协办单位 &nbsp;</h6>
            <p class="itemStyle" v-for="item in CoorganizerList">
              {{ item.title }}
            </p>
          </div>
        </div>
        <div class="link_left">
          <div class="link_left-item">
            <h6>联系方式</h6>
            <div class="link_mid_phone">
              <span>联系方式：</span>
              <span v-for="item in ContactWayList">{{ item.title }}</span>
            </div>
            <span>地址：</span
            ><span v-for="item in AddressList">{{ item.title }}</span>
            <div class="link_right">
              <div>
                <img :src="qrCode" alt="公众号二维码" />
                <div class="link_right_text">四川省再生资源行业协会公众号</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright">
        <span>版权所有 © 四川省天府再生集团</span>
        <div class="copyCode">
          <img
            :src="require('@/assets/recycling/index/record-img.png')"
            alt=""
          />
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            rel="noreferrer"
            target="_blank"
          >
            蜀ICP备2025151940号
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getHomeData } from '@/API/home/home.js';

export default {
  name: 'bottomUrl',
  data() {
    return {
      qrCode: require('@/assets/recycling/index/qrCode.jpg'),
      linkType: [
        {
          name: '四川省人民政府',
          link: 'https://www.sc.gov.cn/',
        },
        {
          name: '四川省发展和改革委员会',
          link: 'https://fgw.sc.gov.cn/',
        },
        {
          name: '四川省商务厅',
          link: 'https://swt.sc.gov.cn/',
        },
        {
          name: '四川省供销合作网',
          link: 'https://www.scco-op.com/',
        },
        {
          name: '四川省经济和信息化厅',
          link: 'https://jxt.sc.gov.cn/',
        },
        {
          name: '四川省住房和城乡建设厅',
          link: 'http://jst.sc.gov.cn/',
        },
        {
          name: '四川省生态环境厅',
          link: 'https://sthjt.sc.gov.cn/',
        },
        {
          name: '四川省农业农村厅',
          link: 'http://nynct.sc.gov.cn/',
        },
      ],
      Contact: {
        phone: '028-83388891',
        address: '四川省成都市金牛区新现代大厦406',
      },
      GuidingList: [],
      OrganizerList: [],
      CoorganizerList: [],
      ContactWayList: [],
      AddressList: [],
    };
  },
  mounted() {
    this.getHomeData();
  },
  methods: {
    // 固定链接跳转
    openTankUrl(data) {
      window.open(data.linkUrl);
    },
    getHomeData() {
      getHomeData('footerPage').then((res) => {
        if (res.code == 200) {
          res.data.map((item) => {
            //指导单位数据处理
            if (item.moduleKey === 'Guiding') {
              this.GuidingList = item.contents;
            }
            //主办单位数据处理
            if (item.moduleKey === 'Organizer') {
              this.OrganizerList = item.contents;
            }
            //协办单位数据处理
            if (item.moduleKey === 'Co-organizer') {
              this.CoorganizerList = item.contents;
            }
            //联系方式数据处理
            if (item.moduleKey === 'Contact-way') {
              this.ContactWayList = item.contents;
            }
            //地址数据处理
            if (item.moduleKey === 'Address') {
              this.AddressList = item.contents;
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.smallScreen {
  display: none;
}

.link {
  height: 190px;
  padding: 0 310px;
  background: #282828ff;
  border-bottom: 1px solid gray;
  display: flex;

  .itemStyle {
    cursor: pointer;
  }

  .link_right {
    width: 20%;
    height: inherit;
    padding: 40px 0;
  }

  .link_mid {
    width: 35%;
    height: inherit;
    padding: 40px 0;
  }

  .link_left {
    width: 45%;
    height: inherit;
    padding: 40px 0;
  }

  .link_left {
    .link_left_title {
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 1px;
      line-height: 26.06px;
      color: rgba(255, 255, 255, 1);
      margin-bottom: 20px;
    }

    .link_left_herf {
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 1px;
      line-height: 20.27px;
      color: rgba(255, 255, 255, 1);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .link_left_herf_warpper {
        margin-bottom: 14px;

        a {
          display: inline-block;
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        a:hover {
          color: #c7c6c6c1;
        }
      }
    }

    .link_left-item {
      height: 18px;
      margin-bottom: 18px;
      color: #fff;
      font-weight: 400;

      span {
        font-size: 14px;
      }
    }
  }

  .link_mid {
    padding-left: 65px;

    .link_mid_title {
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 1px;
      line-height: 26.06px;
      color: rgba(255, 255, 255, 1);
      margin-bottom: 20px;
    }

    .link_mid_phone,
    .link_mid_address {
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 1px;
      line-height: 20.27px;
      max-height: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
    }

    .link_mid_phone {
      margin-bottom: 20px;
    }
  }

  .link_right {
    display: flex;
    justify-content: right;
    align-items: center;

    img {
      width: 88px;
      height: 88px;
      margin: 0 auto;
    }

    .link_right_text {
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 1px;
      line-height: 20.27px;
      color: rgba(255, 255, 255, 1);
      margin-top: 12px;
      text-align: center;
    }
  }
}

.copyright {
  height: 100px;
  background: #282828ff;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;

  img {
    width: 14px;
    height: 14px;
    margin: 0 10px 0 20px;
  }
}

@media screen and (max-width: 768px) {
  .bigScreen {
    display: none !important;
  }

  .smallScreen {
    display: block !important;

    .link1 {
      background: #282828ff;
      padding: 0 15px !important;
      text-align: center;

      .itemStyle {
        cursor: pointer;
        font-size: 14px;
        color: #ddd;
        padding: 5px 0;
      }

      .link_left {
        .link_left_title {
          color: rgba(255, 255, 255, 1);
          margin-bottom: 20px;
        }

        .link_left_herf {
          color: rgba(255, 255, 255, 1);

          .link_left_herf_warpper {
            margin-bottom: 14px;

            a {
              display: inline-block;
              width: 150px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            a:hover {
              color: #c7c6c6c1;
            }
          }
        }

        .link_left-item {
          color: #fff;
          border-bottom: 1px solid gray;
          padding: 20px 0;

          h6 {
            font-size: 16px !important;
          }

          span {
            font-size: 14px !important;
            color: #ddd;
          }
        }
      }

      .link_mid {
        .link_mid_title {
          margin-bottom: 20px;
        }

        .link_mid_phone,
        .link_mid_address {
          font-size: 14px;
        }

        .link_mid_phone {
          margin-bottom: 20px;
        }
      }

      .link_right {
        padding-top: 50px;

        img {
          width: 88px;
          height: 88px;
          margin: 0 auto;
        }

        .link_right_text {
          font-size: 16px;
          color: #ddd;
          margin-top: 12px;
          text-align: center;
        }
      }
    }

    .copyright {
      padding: 20px;
      text-align: center;
      height: 120px;
      background: #282828ff;
      font-size: 14px;
      font-weight: 400;
      color: #909399;
      display: block !important;

      .copyCode {
        padding-top: 10px;
      }

      img {
        width: 14px;
        height: 14px;
        margin: 0 10px 0 0px;
        display: inline-block;
      }
    }
  }
}
</style>
